import NotFoundComponent from './NotFoundComponent.vue';

export default NotFoundComponent;
